function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classnames from 'classnames';
import styles from './Avatar.scss';

function Avatar(_ref) {
  var _classnames;

  var onClick = _ref.onClick,
      size = _ref.size,
      sizeXl = _ref.sizeXl,
      sizeLg = _ref.sizeLg,
      sizeSm = _ref.sizeSm,
      sizeXs = _ref.sizeXs,
      src = _ref.src,
      alt = _ref.alt,
      online = _ref.online,
      userName = _ref.userName,
      className = _ref.className,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var nameFirstLetter = userName != null ? userName.charAt(0) : '';
  var isClickable = Boolean(onClick);
  var Tag = isClickable ? 'button' : 'div';
  return /*#__PURE__*/React.createElement(Tag, {
    type: isClickable ? 'button' : undefined,
    onClick: onClick,
    className: classnames(styles.avatar, className, styles["size--".concat(size)], (_classnames = {}, _defineProperty(_classnames, styles["size-xl--".concat(String(sizeXl))], Boolean(sizeXl)), _defineProperty(_classnames, styles["size-lg--".concat(String(sizeLg))], Boolean(sizeLg)), _defineProperty(_classnames, styles["size-sm--".concat(String(sizeSm))], Boolean(sizeSm)), _defineProperty(_classnames, styles["size-xs--".concat(String(sizeXs))], Boolean(sizeXs)), _defineProperty(_classnames, styles.isClickable, isClickable), _defineProperty(_classnames, styles.isDisabled, isDisabled), _classnames))
  }, src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    className: styles.image
  }) : /*#__PURE__*/React.createElement("div", {
    className: styles.firstLetter
  }, " ", nameFirstLetter, " "), online && /*#__PURE__*/React.createElement("div", {
    className: styles.online
  }));
}

Avatar.defaultProps = {
  onClick: undefined,
  size: 'standard',
  sizeXl: undefined,
  sizeLg: undefined,
  sizeSm: undefined,
  sizeXs: undefined,
  src: null,
  alt: null,
  online: false,
  className: undefined
};
export default Avatar;